<script setup lang="ts">
// Karta: plocha --surface, jemný rámeček. `ai` přidá magenta levý proužek (neschválený návrh).
withDefaults(defineProps<{ ai?: boolean; interactive?: boolean; as?: string }>(), {
  ai: false,
  interactive: false,
  as: 'div',
})
</script>

<template>
  <component
    :is="as"
    class="wb-card"
    :class="{ 'wb-card--ai': ai, 'wb-card--interactive': interactive }"
  >
    <slot />
  </component>
</template>

<style scoped>
.wb-card {
  background: var(--surface);
  color: var(--text);
  border: 1px solid var(--border-soft);
  border-radius: var(--radius-lg);
  padding: var(--space-3) var(--space-4);
  box-shadow: var(--shadow-sm);
  text-align: left;
  width: 100%;
}
.wb-card--ai {
  border-left: 4px solid var(--ai);
}
.wb-card--interactive {
  cursor: pointer;
  transition:
    border-color var(--dur-fast) var(--ease),
    box-shadow var(--dur-base) var(--ease);
}
.wb-card--interactive:hover {
  border-color: var(--border-strong);
  box-shadow: var(--shadow-md);
}
</style>
